import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProdutoModalComponent } from '../_components/produto-modal/produto-modal.component';
import { Observable } from 'rxjs';
import { FilterData } from '../_models/FilterData';
import { Produto } from '../_models';

@Injectable()
export class ProdutoModalService {
  constructor(private matDialog: MatDialog) { }
  public open(filterData: FilterData): Observable<Produto[]> {
    const matDialogRef: MatDialogRef<ProdutoModalComponent> = this.matDialog.open(
      ProdutoModalComponent,
      { minWidth: '75%', maxWidth: '75%', maxHeight: '600px', disableClose: true, data: filterData }
    );
    return matDialogRef.afterClosed();
  }
}
